export default __webpack_public_path__ + "static/media/SCADA.12d8d62b.gif";